import React from 'react';
import { toLower } from 'lodash';
import { makeHtml } from '../../services/cms/markdownConverter.js';
const configHelper = require('../../config/index');

import './ImagePlusText.scss';

const ImagePlusText = ({
    orientation,
    url,
    width,
    height,
    text,
    imageUrl = '#',
    caption = '',
    imgRootUrl = configHelper.getConfig().cms.cmsUrl,
}) => {
    const imgToRight = toLower(orientation) === 'right';
    if (imgToRight) {
        return (
            <div className='image-plus-text right'>
                <div className='image-plus-text-container'>
                    <div className='image-plus-text-container__text p-right'>
                        <p
                            className='image-plus-text-container__htmlcontent'
                            dangerouslySetInnerHTML={{
                                __html: makeHtml(text),
                            }}></p>
                    </div>
                    <div className='image-container'>
                        <div className='image-wrapper'>
                            <a href={imageUrl}>
                                <img
                                    className='animated-image image-plus-text-container__image'
                                    src={`${imgRootUrl}${url}`}
                                    width={width}
                                    height={height}></img>
                            </a>
                        </div>
                    </div>
                </div>
                <div className='caption-container'>
                    <div className='caption-left'></div>
                    <div
                        className='caption-right'
                        dangerouslySetInnerHTML={{ __html: caption }}></div>
                </div>
            </div>
        );
    }
    return (
        <div className='image-plus-text left'>
            <div className='image-plus-text-container'>
                <div className='image-container'>
                    <div className='image-wrapper'>
                        <a href={imageUrl}>
                            <img
                                className='animated-image image-plus-text-container__image'
                                src={`${imgRootUrl}${url}`}
                                width={width}
                                height={height}></img>
                        </a>
                    </div>
                </div>
                <div className='image-plus-text-container__text p-left'>
                    <p
                        className='image-plus-text-container__htmlcontent'
                        dangerouslySetInnerHTML={{
                            __html: makeHtml(text),
                        }}></p>
                </div>
            </div>
            <div className='caption-container'>
                <div className='caption-left'></div>
                <div
                    className='caption-right'
                    dangerouslySetInnerHTML={{ __html: caption }}></div>
            </div>
        </div>
    );
};

export default ImagePlusText;
